const calcUa = {
  heroTitle: "Калькулятор <1>матриці долі</1>",
  heroAboutCalc:
    "Поглиблений калькулятор для швидкого та професійного розрахунку.",
  heroAuthoring:
    "Калькулятор на 100% відповідає класичному обчисленню «Матриця Долі» Наталії Ладіні",
  changeYourFateTitle: "Вкотре намагаєшся розшифрувати свою матрицю долі?",
  changeYourFateAssistanseText:
    "Це взагалі не головне. Набагато важливіше знати, як з її допомогою реально змінити своє життя. І ось із цим я допоможу.",
  changeYourFateConsultationBtn: "ОБРАТИ ФОРМАТ КОНСУЛЬТАЦІЇ",
  changeYourFateCalcAuthor1:
    "Навчитися всім професійним розрахункам можна у майстрів",
  changeYourFateCalcAuthor2: "Наталії Ладіні",
  changeYourFateCalcAuthor3: "та",
  changeYourFateCalcAuthor4: "Сергія Скляренко",
  donationLikeTheProject:
    "Якщо тобі подобається калькулятор — допоможе йому залишатися безкоштовно.",
  donationSaveService:
    "Оформи невелику передплату або залиш разовий донат. Твоя підтримка допомагає оплачувати роботу сервісу, розвивати його та зберігати безкоштовний доступ для всіх.",
  contactsTitle: "Контакти",
  getPDFTemplateTitle: "Отримай PDF-шаблон для розрахунку Матриці Долі!",
  getPDFTemplateHowTo1: "Долучайся до сторінки",
  getPDFTemplateHowTo2:
    "та напиши в особисті повідомлення кодову фразу “Хочу Шаблони”",
  footerPoliticText1: "Політика конфіденційності",
  footerPoliticText2: "Розроблено командою dari.karma",
  fullOverlapCheckbox: "Техніка повного накладання матриць",
  method2023: "Техніка накладання 8 карм",
  personalMatrixCalc: "розрахувати",
  personalMatrixBoxTitle: "введіть дані",
  personalMatrixNamePlaceholder: "Ім’я",
  personalMatrixDatePlaceholder: "Дата  народження",
  personalMatrixDateRequired: "Введіть дату",
  personalMatrixDatePattern: "Введіть дату в форматі dd.mm.yyyy",
  aboutCustomerAge: "Вік",
  aboutCustomerPeriod: "Період",
  assignmentTabledfirstName1: "Небо",
  assignmentTabledfirstName2: "Батько",
  assignmentTabledsecondName1: "Земля",
  assignmentTabledsecondName2: "Мати",
  assignmentTabledthrirdName1: "Особисте",
  assignmentTabledthrirdName2: "Соціальне",
  assignmentTabledname1: "Духовне",
  assignmentTabledname2: "Планетарне",
  assignmentTabledkey: "Ключ сили",
  assignmentTabledthrirdNameDesk1: "Особисте призначення",
  assignmentTabledthrirdNameDesk2: "Соціальне призначення",
  karmaIssuesEnergy: "Енергія",
  healthAuthor: "авторська",
  healthAuthorPasswordModalData: "Введіть ключ доступу",
  incorrectPassword: "! Невірний пароль",
  healthAuthorWarning1:
    '<0>УВАГА!</0> Система "INTEGRITY" є розробкою команди "Dari.Karma" та представлена на сайті для тестування.',
  healthAuthorWarning2:
    "Даний розрахунок карти здоров'я <1>не відповідає </1> алгоритму розрахунку Н. Ладіні",
  healthCardTypePersonal: "Класична",
  healthCardTipPurpose: "Функція",
  healthCardTipInternalCondition: "Внутрішній стан",
  healthCardTipDisturbance: "Порушення",
  healthCardTipVerb: "Дієслово",
  check: "Переглянути",
  healthAuthorLesson: 'УРОК ПРО СИСТЕМУ "INTEGRITY"',
  result: "Результат",
  periodMatrixHeader: "Енергії покровителі періодів",
  tableMatrix: "Матриця",
  compatibility: "Сумісність",
  classic: "Класична",
  compatibilityMatrix: "МАТРИЦЯ СУМІСНОСТІ",
  add: "Додати",
  annualMatrix: "Матриця року",
  year: "Рік",
  yearEnterError: "Введіть рік",
  yearPatternError: "Введіть 4-значний рік від 2000 до 2100",
  yearPeriods: "Періоди року",
  deepCalcProg: "ПРОГРАМИ",
  deepGenericBtn1: "РОДОВІ",
  deepGenericBtn2: "Цілісні",
  motherMatrixTitle: "МАТРИЦЯ МАТЕРІ",
  childMatrixTitle: "МАТРИЦЯ ДИТИНИ",
  instructionTitle:
    "Використовуй можливості калькулятора від <1>Dari.Karma</1> на всі 100%",
  instructionCircleBtn1: "Відеоінструкція до калькулятора",
  instructionCircleBtn2: "Безкоштовні вебінари про “INTEGRITY”",
  instructionBtn1: "Відеоінструкція до калькулятора",
  instructionBtn2: "Безкоштовні вебінари про “INTEGRITY”",
  instructionModalTitle1: "Секретні фішки калькулятора",
  instructionModalTitle2: 'Вебінари про систему "INTEGRITY"',
  instructionModalBtn1: "купити інструкцію",
  instructionModalBtn2: "Дивитися безкоштовно",
  deepLightGateBtn: "Зцілення",
};
export default calcUa;
